import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SpecificationList } from '@celum/formats/domain';

import { SpecificationContractServiceBase } from './specification-contract-service-base';

/**
 * Single implementation of specification-related API calls shared by the standalone `formats` app and the
 * `formats-embed` app. The environment-specific concerns (apiUrl/tenant resolution, authentication headers for
 * embedded calls) are handled by `FormatsContextAware` based on the `FORMATS_CONTEXT` provided where this service
 * is registered.
 */
@Injectable()
export class SpecificationsService extends SpecificationContractServiceBase {
  public getSpecifications(): Observable<SpecificationList> {
    return this.withContext(context => this.http.get<SpecificationList>(`${this.apiUrl}/specifications`, { context }));
  }
}
